import { useAtomValue, useSetAtom } from 'jotai';

import { LeadsTableTab } from '@ekhodealer/ekho-common';

import { AccordionSection } from '@common/components/AccordionSection';
import {
	FiltersDrawerCheckboxGroup,
	type FiltersDrawerCheckboxGroupItem,
} from '@common/components/FilterGroups/FiltersDrawerCheckboxGroup';

import { pipelineFilterAtom, updatePipelineFilterAtom } from '../../atoms/leadsAtoms';
import { useLeadsFacetCounts } from '../../hooks/useLeadsFacetCounts';

/** Display labels for pipeline filter options */
const PIPELINE_OPTIONS: { value: string; label: string }[] = [
	{ value: LeadsTableTab.INBOUND, label: 'Inbound' },
	{ value: LeadsTableTab.DIGITAL_RETAIL, label: 'Digital retail' },
];

/**
 * FiltersDrawerPipelineSection component that provides a pipeline filter
 * with checkboxes for Inbound and Digital retail
 */
export function FiltersDrawerPipelineSection(): React.ReactNode {
	const pipelines = useAtomValue(pipelineFilterAtom);
	const setPipelineFilter = useSetAtom(updatePipelineFilterAtom);
	const { pipelineCounts } = useLeadsFacetCounts();

	const items: FiltersDrawerCheckboxGroupItem[] = PIPELINE_OPTIONS.map(({ value, label }) => ({
		value,
		label,
		count: pipelineCounts[value as LeadsTableTab] ?? 0,
	}));

	const hasAppliedFilters = pipelines.length > 0;

	return (
		<AccordionSection title='Pipeline' defaultExpanded={hasAppliedFilters}>
			<FiltersDrawerCheckboxGroup
				label=''
				items={items}
				value={pipelines}
				onChange={setPipelineFilter}
			/>
		</AccordionSection>
	);
}
